// Compiled at 2026-05-13T13:50:05.286Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => ExpenseStatus.loadInternal(), entryList => {
        ExpenseStatus.θentryList.set(entryList)
        ExpenseStatus.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class ExpenseStatus {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<ExpenseStatus.Id>;
    static readonly Id = String;
    static θentryList = signal<ReadonlyArray<ExpenseStatus.Entry> | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<ExpenseStatus.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => ExpenseStatus.getEntryMap()[this.θid()]?.label);
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return ExpenseStatus[BoInfoSymbol]
    }

    get __type(): 'Llama.ExpenseStatus' {
        return 'Llama.ExpenseStatus'
    }

    set __type(_) {
    }

    static get __type(): 'Llama.ExpenseStatus' {
        return 'Llama.ExpenseStatus'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id() {
        return this.θid()
    }

    set id(id: ExpenseStatus.Id) {
        if (id != null && !ExpenseStatus.getEntry(id)) throw new Error('Invalid id for type Llama.ExpenseStatus: ' + id)
        this.θid.set(id)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[ExpenseStatus.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isnew() {
        return this.id == 'new'
    }

    static get new() {
        return new this('new')
    }

    get isunverified() {
        return this.id == 'unverified'
    }

    static get unverified() {
        return new this('unverified')
    }

    get isverified() {
        return this.id == 'verified'
    }

    static get verified() {
        return new this('verified')
    }

    get isreimbursed() {
        return this.id == 'reimbursed'
    }

    static get reimbursed() {
        return new this('reimbursed')
    }

    get iserror() {
        return this.id == 'error'
    }

    static get error() {
        return new this('error')
    }

    constructor(id: ExpenseStatus.Id = null) {
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]) {
        return This.ExpenseStatus.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]) {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: ExpenseStatus.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof ExpenseStatus.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = ExpenseStatus.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<ExpenseStatus.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new ExpenseStatus(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θupdate(idOrObject: ExpenseStatus.Id | ExpenseStatus) {
        if (idOrObject && typeof idOrObject == 'object') {
            this.id = idOrObject.id

        } else {
            this.id = idOrObject as any
        }
    }

    static θonEntryListUpdated() {
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Llama.ExpenseStatus yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setnew() {
        this.id = 'new'

    }

    setunverified() {
        this.id = 'unverified'

    }

    setverified() {
        this.id = 'verified'

    }

    setreimbursed() {
        this.id = 'reimbursed'

    }

    seterror() {
        this.id = 'error'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "new", label: "New" }),
            Object.freeze({ id: "unverified", label: "Unverified" }),
            Object.freeze({ id: "verified", label: "Verified" }),
            Object.freeze({ id: "reimbursed", label: "Reimbursed" }),
            Object.freeze({ id: "error", label: "Error" })
        ])
    }
}
jsonClass('Llama.ExpenseStatus')(ExpenseStatus)

export const ExpenseStatusθId = String;

export type ExpenseStatusθId = string;

export namespace ExpenseStatus {
    export type Id = 'new' | 'unverified' | 'verified' | 'reimbursed' | 'error'

    export interface Entry {
        id: string;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => ExpenseStatus.load(true))
